import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import TermsAndConditionsPreview from './TermsAndConditionsPreview';

@Component({
  selector: 'terms-and-conditions-preview-react',
  templateUrl: './terms-and-conditions-preview-react-container.component.html',
  styleUrls: ['./terms-and-conditions-preview-react-container.component.scss'],
  standalone: true,
})
export class TermsAndConditionsPreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @Input() showHamburger: boolean = true;
  @Input() color: string;
  reactWrapperId: string;
  root: Root = null;

  constructor() {}

  ngOnInit() {
    this.reactWrapperId = 'terms-and-conditions-preview';
  }

  protected getRootDomNode() {
    const node = document.getElementById(this.reactWrapperId);
    return node;
  }

  ngOnDestroy(): void {
    this.root?.unmount();
  }

  ngOnChanges(): any {
    this.render();
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(TermsAndConditionsPreview, {
          showMenu: this.showHamburger,
          color: this.color,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }
}
